document.addEventListener('DOMContentLoaded', function() {
  // Mobile menu toggle
  const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');
  
  if (mobileMenuToggle && mobileMenu) {
    mobileMenuToggle.addEventListener('click', function() {
      const expanded = mobileMenuToggle.getAttribute('aria-expanded') === 'true';
      mobileMenuToggle.setAttribute('aria-expanded', !expanded);
      mobileMenu.hidden = expanded;
    });
  }
  
  // Sticky header
  const header = document.querySelector('.header');
  const stickyEnabled = header?.dataset.sticky === 'true';
  
  if (stickyEnabled && header) {
    const headerHeight = header.offsetHeight;
    const scrollWatcher = () => {
      if (window.scrollY > headerHeight) {
        header.classList.add('is-sticky');
      } else {
        header.classList.remove('is-sticky');
      }
    };
    
    window.addEventListener('scroll', scrollWatcher);
  }
  
  // Cart drawer functionality
  const cartToggle = document.querySelector('.cart-toggle');
  const cartDrawer = document.getElementById('cart-drawer');
  const cartClose = document.querySelector('.cart-drawer__close');
  const cartOverlay = document.querySelector('.cart-drawer__overlay');
  
  if (cartToggle && cartDrawer) {
    cartToggle.addEventListener('click', function(e) {
      e.preventDefault();
      document.body.classList.add('cart-drawer-open');
      cartDrawer.classList.add('is-open');
    });
    
    const closeCartDrawer = () => {
      document.body.classList.remove('cart-drawer-open');
      cartDrawer.classList.remove('is-open');
    };
    
    if (cartClose) {
      cartClose.addEventListener('click', closeCartDrawer);
    }
    
    if (cartOverlay) {
      cartOverlay.addEventListener('click', closeCartDrawer);
    }
  }
  
  // Quantity input handlers
  const quantityInputs = document.querySelectorAll('.quantity-input');
  
  if (quantityInputs.length > 0) {
    quantityInputs.forEach(input => {
      const decrementBtn = input.parentNode.querySelector('.quantity-decrement');
      const incrementBtn = input.parentNode.querySelector('.quantity-increment');
      
      if (decrementBtn) {
        decrementBtn.addEventListener('click', () => {
          const currentValue = parseInt(input.value);
          if (currentValue > 1) {
            input.value = currentValue - 1;
            input.dispatchEvent(new Event('change'));
          }
        });
      }
      
      if (incrementBtn) {
        incrementBtn.addEventListener('click', () => {
          const currentValue = parseInt(input.value);
          input.value = currentValue + 1;
          input.dispatchEvent(new Event('change'));
        });
      }
    });
  }
  
  // Update cart quantities
  const cartQuantityForms = document.querySelectorAll('.cart-item-quantity form');
  
  if (cartQuantityForms.length > 0) {
    cartQuantityForms.forEach(form => {
      const quantityInput = form.querySelector('.quantity-input');
      
      if (quantityInput) {
        quantityInput.addEventListener('change', () => {
          form.submit();
        });
      }
    });
  }

  // Bubble animation
  createBubbles();
  
  // Recreate bubbles on window resize for responsiveness
  window.addEventListener('resize', function() {
    createBubbles();
  });
});

function createBubbles() {
  const bubbleSections = document.querySelectorAll('.bubble-animation');
  
  bubbleSections.forEach(section => {
    // Clear existing bubbles
    section.innerHTML = '';
    
    // Define the bubble types with their colors
    const bubbleTypes = [
      'bubble-primary',
      'bubble-secondary', 
      'bubble-accent', 
      'bubble-highlight'
    ];
    
    // Create 20 bubbles for a richer effect
    const numBubbles = 20;
    
    for (let i = 0; i < numBubbles; i++) {
      const bubble = document.createElement('div');
      bubble.classList.add('bubble');
      
      // Randomly select bubble type
      const randomType = bubbleTypes[Math.floor(Math.random() * bubbleTypes.length)];
      bubble.classList.add(randomType);
      
      // Random horizontal position
      bubble.style.left = `${Math.random() * 100}%`;
      
      // Random size between 20px and 80px for variety
      const size = 20 + Math.random() * 60;
      bubble.style.width = `${size}px`;
      bubble.style.height = `${size}px`;
      
      // Random animation delay for a staggered effect
      bubble.style.animationDelay = `${Math.random() * 15}s`;
      
      // Random animation duration between 8s and 20s
      bubble.style.animationDuration = `${8 + Math.random() * 12}s`;
      
      // Add each bubble to the section
      section.appendChild(bubble);
    }
    
    // Add a few soap bubbles for visual interest
    for (let i = 0; i < 5; i++) {
      const soapBubble = document.createElement('div');
      soapBubble.classList.add('soap-bubble');
      
      // Random position
      soapBubble.style.left = `${Math.random() * 90}%`;
      soapBubble.style.top = `${Math.random() * 80}%`;
      
      // Random size between 30px and 60px
      const soapSize = 30 + Math.random() * 30;
      soapBubble.style.width = `${soapSize}px`;
      soapBubble.style.height = `${soapSize}px`;
      
      // Random animation delay
      soapBubble.style.animationDelay = `${Math.random() * 5}s`;
      
      // Add to section
      section.appendChild(soapBubble);
    }
  });
}